import { render, staticRenderFns } from "./HorarioClinica.vue?vue&type=template&id=61024e6e&scoped=true"
import script from "./HorarioClinica.vue?vue&type=script&lang=js"
export * from "./HorarioClinica.vue?vue&type=script&lang=js"
import style0 from "./HorarioClinica.vue?vue&type=style&index=0&id=61024e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61024e6e",
  null
  
)

export default component.exports